export const authKeys = {
  all: ['auth'] as const,
  customerInfo: (cId: number) => [...authKeys.all, 'customerInfo', cId] as const,
} as const;
